import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SkeletonRectComponent } from './skeleton-rect.component';

@Directive({
  selector: '[appSkeleton]'
})
export class SkeletonDirective {
  private isLoading = false;

  @Input('appSkeleton') set loading(value: boolean) {
    this.isLoading = value;
    this.updateView();
  }

  @Input('appSkeletonCount') count = 3;
  @Input('appSkeletonWidth') width = '100%';
  @Input('appSkeletonHeight') height = '16px';
  @Input('appSkeletonClass') customClass = '';
  @Input('appSkeletonRadius') radius = '6px';

  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef) {}

  private updateView(): void {
    this.vcr.clear();
    if (this.isLoading) {
      for (let i = 0; i < this.count; i++) {
        const compRef = this.vcr.createComponent(SkeletonRectComponent);
        compRef.setInput('width', this.width);
        compRef.setInput('height', this.height);
        compRef.setInput('customClass', this.customClass);
        compRef.setInput('borderRadius', this.radius);
      }
    } else {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}


